import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateQualificationRequest extends BaseUpdateRequest {
    name = '';
    description = '';
}